export const IDP_EXPIRY_REFRESH_BUFFER_SEC = 60;
export const IDP_FRESHNESS_MIN_SEC = IDP_EXPIRY_REFRESH_BUFFER_SEC + 30;
